import AppListing from '../app-components/Listing/AppListing';

Vue.component('work-days-summary-listing', {
    mixins: [AppListing],
    data() {
        return {
            daysInCurrentMonth: [],
            selectedMonthMutable: {},
            selectedContractTypeMutable: {},
            filters: {
                contractType: null
            },
            orderBy: {
                column: 'last_name',
                direction: 'asc'
            },
            initSetDataComplete: false,
            mutableUrl: '',
            dateUrlPath: '',
            loading: false,
            year: null,
            month: null
        };
    },

    props: {
        'baseUrl': {
            type: String
        },
        'transMonths': {
            type: Object
        },
        /*'avalaibleMonths': {
            type: Array,
            default() {
                return [];
            }
        },*/
        'selectedMonth': {
            type: Object,
            default() {
                return null;
            }
        },
        'selectedContractType': {
            type: Object,
            default() {
                return null;
            }
        },
        'avalaibleContractTypes': {
            type: Array,
            default() {
                return [];
            }
        }
    },

    created() {
        if (this.data != null) {
            this.populateCurrentStateAndData(this.data);
        } else {
            this.loadData();
        }

        this.year = Number( moment(this.selectedMonth.key).format('YYYY') );
        this.month = Number( moment(this.selectedMonth.key).format('MM') );

        this.selectedMonthMutable = this.selectedMonth.key;
        this.selectedContractTypeMutable = this.selectedContractType;
        this.mutableUrl = this.url;

        const monentSelectedMonth = moment(this.selectedMonth.key, "YYYY-MM");
        this.dateUrlPath = `${monentSelectedMonth.format("YYYY")}/${monentSelectedMonth.format("MM")}`;

        this.daysInCurrentMonth = this.getDaysInMonth(monentSelectedMonth.format("YYYY"), monentSelectedMonth.format("MM"));

        this.$nextTick(function () {
            this.initSetDataComplete = true;
            // this.refreshData();
        });
    },

    methods: {
        chooseMonth(year, month) {
            this.selectedMonthMutable = year+"-"+(month < 10 ? "0":"")+month;

            this.year = year;
            this.month = month;

            const momentDate = moment(this.selectedMonthMutable, "YYYY-MM");

            this.dateUrlPath = momentDate.format("YYYY/MM");
            this.daysInCurrentMonth = this.getDaysInMonth(momentDate.format('YYYY'), momentDate.format('MM'));

            this.mutableUrl = this.baseUrl+"/"+this.dateUrlPath;

            this.refreshData();
        },

        getDaysInMonth(year, month) {
            var date = new Date(year, month - 1, 1);
            var result = [];

            while (date.getMonth() == month - 1) {
                result.push(moment(date));
                date.setDate(date.getDate() + 1);
            }

            return result;
        },

        getDayClass(workDays, date, prefix) {
            const workDay = workDays.find(workDay => {
                return moment(workDay.date).format('D') === date.format('D');
            });

            if(workDay) {
                return workDay.workIntervalOverflow ? `${prefix}-danger` : `${prefix}-success` ;
            } else {
                return `${prefix}-secondary`;
            }
        },

        getDayHighlightClass(date) {
            var cls = '';

            // add highlight for weekends
            if(moment(date).isoWeekday() >= 6)
            {
                cls += ' weekend';
            }

            return cls;
        },

        setContractType(contractType) {
            let val = this.filters.contractType;
            if(!val) val = null;
            this.selectedContractTypeMutable = this.avalaibleContractTypes.find(x => x.key == val);
        },

        refreshData() {
            if(this.initSetDataComplete) {

                if(window.history.replaceState) {
                    let newUrl = this.mutableUrl;

                    if(this.filters.contractType) {
                        newUrl = `${newUrl}?contractType=${this.filters.contractType}`;
                    }

                    window.history.replaceState({}, null, newUrl);
                }

                this.loadData(true);
            }
        },

        //from BaseListing
        loadData: function loadData(resetCurrentPage) {
            var _this = this;

            var options = {
                params: {
                    per_page: this.pagination.state.per_page,
                    page: this.pagination.state.current_page,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction
                }
            };

            if (resetCurrentPage === true) {
                options.params.page = 1;
            }

            Object.assign(options.params, this.filters);

            axios.get(this.mutableUrl, options).then(function (response) {
                return _this.populateCurrentStateAndData(response.data.data);
            }, function (error) {
                // TODO handle error
            });
        },

        resetFilter() {
            this.filters.contractType=null;
        },

        isFiltered() {
            if(this.filters.contractType != null)
            {
                return 1;
            }
            else
            {
                return 0;
            }
        },

    },

    watch: {
        selectedContractTypeMutable: function(newVal, oldVal) {
            if(newVal.key != oldVal.key) {
                this.filters.contractType = newVal.key;
                this.refreshData();
            }
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/work-days-summary/Listing.js